export function getFanToleranceClasses(t) {
  return [
    {
      label: "BV-1 (G16)",
      description: t("toleranceClasses.byFanToleranceClass.bv1.description"),
      value: 16,
    },
    {
      label: "BV-2 (G16)", 
      description: t("toleranceClasses.byFanToleranceClass.bv2.description"),
      value: 16,
    },
    {
      label: "BV-3 (G6.3)",
      description: t("toleranceClasses.byFanToleranceClass.bv3.description"),
      value: 6.3,
    },
    {
      label: "BV-4 (G2.5)",
      description: t("toleranceClasses.byFanToleranceClass.bv4.description"), 
      value: 2.5,
    },
    {
      label: "BV-5 (G1.0)",
      description: t("toleranceClasses.byFanToleranceClass.bv5.description"),
      value: 1.0,
    },
  ];
}

export function getFanTypes(t) {
  return [
    {
        label: t("toleranceClasses.byFan.homeAndOfficeBellow0-15kW.label") + " - BV-1 (G16)",
        description: t("toleranceClasses.byFan.homeAndOfficeBellow0-15kW.description"),
        value: 16,
    },
    {
        label: t("toleranceClasses.byFan.homeAndOfficeAbove0-15kW.label") + " - BV-2 (G16)",
        description: t("toleranceClasses.byFan.homeAndOfficeAbove0-15kW.description"),
        value: 16,
    },
    {
        label: t("toleranceClasses.byFan.buildingsAndAgriculturalBelow3-7kW.label") + " - BV-2 (G16)",
        description: t("toleranceClasses.byFan.buildingsAndAgriculturalBelow3-7kW.description"),
        value: 16,
    },
    {
        label: t("toleranceClasses.byFan.buildingsAndAgriculturalAbove3-7kW.label") + " - BV-3 (G6.3)",
        description: t("toleranceClasses.byFan.buildingsAndAgriculturalAbove3-7kW.description"),
        value: 6.3,
    },
    {
        label: t("toleranceClasses.byFan.technologicalProcessesAndEnergyProductionBelow300kW.label") + " - BV-3 (G6.3)",
        description: t("toleranceClasses.byFan.technologicalProcessesAndEnergyProductionBelow300kW.description"),
        value: 6.3,
    },
    // {
    //     label: t("ToleranceClasses.ByFan.TechnologicalProcessesAndEnergyProductionAbove300kW.Label"),
    //     description: t("ToleranceClasses.ByFan.TechnologicalProcessesAndEnergyProductionAbove300kW.Description"),
    //     value: 6.0,
    // },
    {
        label: t("toleranceClasses.byFan.transportAndMarineBelow15kW.label") + " - BV-3 (G6.3)",
        description: t("toleranceClasses.byFan.transportAndMarineBelow15kW.description"),
        value: 6.3,
    },
    {
        label: t("toleranceClasses.byFan.transportAndMarineAbove15kW.label") + " - BV-4 (G2.5)",
        description: t("toleranceClasses.byFan.transportAndMarineAbove15kW.description"),
        value: 2.5,
    },
    {
        label: t("toleranceClasses.byFan.tunnelsBelow75kW.label") + " - BV-3 (G6.3)",
        description: t("toleranceClasses.byFan.tunnelsBelow75kW.description"),
        value: 6.3,
    },
    {
        label: t("toleranceClasses.byFan.tunnelsAbove75kW.label") + " - BV-4 (G2.5)",
        description: t("toleranceClasses.byFan.tunnelsAbove75kW.description"),
        value: 2.5,
    },
    {
        label: t("toleranceClasses.byFan.petrochemicalBelow37kW.label") + " - BV-3 (G6.3)",
        description: t("toleranceClasses.byFan.petrochemicalBelow37kW.description"),
        value: 6.3,
    },
    {
        label: t("toleranceClasses.byFan.petrochemicalAbove37kW.label") + " - BV-4 (G2.5)",
        description: t("toleranceClasses.byFan.petrochemicalAbove37kW.description"),
        value: 2.5,
    },
    {
        label: t("toleranceClasses.byFan.computerChips.label") + " - BV-5 (G1.0)",
        description: t("toleranceClasses.byFan.computerChips.description"),
        value: 1.0,
    },
];;
}
